import { render, staticRenderFns } from "./ren-process-multiple.vue?vue&type=template&id=6689d149"
import script from "./ren-process-multiple.vue?vue&type=script&lang=js"
export * from "./ren-process-multiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports